import axios from 'axios';
import {
  ACCESS_TOKEN_KEY,
  BASE_URL,
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_BASE_URL,
  ADS_API_BASE_URL,
} from '../constants/config.ts';

export const getToken = () => {
  if (localStorage.getItem(ACCESS_TOKEN_KEY)) {
    return JSON.parse(localStorage.getItem(ACCESS_TOKEN_KEY) || '');
  }

  return null;
};

const getAuthorizationHeader = () => `Bearer ${getToken()}`;

export const axiosAuthInstance = axios.create({
  baseURL: BASE_URL,
  headers: { Authorization: getAuthorizationHeader() },
});

export const axiosInstance = axios.create({ baseURL: BASE_URL });

export const axiosGoogleMapsInstance = axios.create({
  baseURL: GOOGLE_MAPS_BASE_URL,
  params: { key: GOOGLE_MAPS_API_KEY },
});

export const axiosAdsInstance = axios.create({
  baseURL: ADS_API_BASE_URL,
});
